export default __webpack_public_path__ + "static/media/h2.7fe1bf4a.png";